/**
 * A stroke on the map -- colour and width -- and the one place its built-in
 * default and its bounds live (review 1.1.0).
 *
 * The same numbers stand in `Settings.php` (`route_width` 1–12, default 4,
 * colour `#007aff`); the map has to draw before the settings are there,
 * which is why the browser carries a copy. One copy, not six: until 1.1.0
 * the default was typed at six places and the bounds at four, and one of
 * them missed would have clamped or diverged silently.
 */
export const STRICH_VORGABE = { farbe: '#007aff', breite: 4 } as const

export const STRICH_GRENZEN = { min: 1, max: 12 } as const
